
var CURRENT_URL = window.location.href.split('#')[0].split('?')[0];
var $BODY = document.body;
var $MENU_TOGGLE = document.getElementById('menu_toggle');
var $SIDEBAR_MENU = document.getElementById('sidebar-menu');
var $SIDEBAR_FOOTER = document.querySelector('.sidebar-footer');
var $LEFT_COL = document.querySelectorAll('.left_col');
var $RIGHT_COL = document.querySelector('.right_col');
var $NAV_MENU = document.querySelector('.nav_menu');
var $FOOTER = document.querySelector('footer');

function initializeParams() {
    CURRENT_URL = window.location.href.split('#')[0].split('?')[0];
    $BODY = document.body;
    $MENU_TOGGLE = document.getElementById('menu_toggle');
    $SIDEBAR_MENU = document.getElementById('sidebar-menu');
    $SIDEBAR_FOOTER = document.querySelector('.sidebar-footer');
    $LEFT_COL = document.querySelectorAll('.left_col');
    $RIGHT_COL = document.querySelector('.right_col');
    $NAV_MENU = document.querySelector('.nav_menu');
    $FOOTER = document.querySelector('footer');
}

document.addEventListener('DOMContentLoaded', function () {
    //initializeSidebar();
    //startMenuOha();
});
document.body.addEventListener('click', function (event) {
    startMenuOha();
});
function startMenuOha() {
    var menuTag = document.querySelector('.menu_oha');
    if (!menuTag) return;
    var dataStarted = menuTag.getAttribute('data-started');
    if (dataStarted) return;

    menuTag.setAttribute('data-started', 'true');
    initializeSidebar();
}
function initializeSidebar() {
    window.intervalId = setInterval(init_sidebar, 500);
}
function init_sidebar() {
    initializeParams();
    if (!$SIDEBAR_MENU) return;
    clearInterval(window.intervalId);

  // Tự động tính chiều cao sidebar
    const setContentHeight = () => {
        return;
    $RIGHT_COL.style.minHeight = `${window.innerHeight}px`;

    const bodyHeight = $BODY.offsetHeight;
    const footerHeight = $BODY.classList.contains('footer_fixed')
      ? -10
      : $FOOTER.offsetHeight;
    const leftColHeight =
      ($LEFT_COL[1]?.offsetHeight || 0) + $SIDEBAR_FOOTER.offsetHeight;
    let contentHeight = Math.max(bodyHeight, leftColHeight);
    contentHeight -= $NAV_MENU.offsetHeight + footerHeight;

    $RIGHT_COL.style.minHeight = `${contentHeight}px`;
  };

  // Đóng tất cả menu
    const openUpMenu = () => {
    $SIDEBAR_MENU.querySelectorAll('li').forEach(li => li.classList.remove('active', 'active-sm'));
    $SIDEBAR_MENU.querySelectorAll('li ul').forEach(ul => {
		//ul.style.display = 'none';
			slideUp(ul);
			setTimeout(setContentHeight, 300);
    });
  };

    // Xử lý click trên từng `a` trong sidebar

  $SIDEBAR_MENU.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', function (ev) {
      const li = this.parentElement;
      const childUl = li.querySelector('ul');

      if (li.classList.contains('active')) {
        li.classList.remove('active', 'active-sm');
        if (childUl) {
          //childUl.style.display = 'none';
          //setContentHeight();
			slideUp(childUl);
			setTimeout(setContentHeight, 300);
        }
      } else {
        if (!li.parentElement.classList.contains('child_menu') ||
            ($BODY.classList.contains('nav-sm') && !li.parentElement.classList.contains('child_menu'))
        ) {
          openUpMenu();
        }

        li.classList.add('active');
        if (childUl) {
          childUl.style.display = 'block';
          //setContentHeight();
			slideDown(childUl);
			setTimeout(setContentHeight, 300);
        }
      }
    });
  });
  
    
    // Toggle menu nhỏ/lớn
  if ($MENU_TOGGLE) {
      $MENU_TOGGLE.addEventListener('click', () => {
      const navMd = $BODY.classList.contains('nav-md');
      $SIDEBAR_MENU.querySelectorAll(navMd ? 'li.active ul' : 'li.active-sm ul')
        .forEach(ul => {
          ul.style.display = navMd ? 'none' : 'block';
        });

      $SIDEBAR_MENU.querySelectorAll(navMd ? 'li.active' : 'li.active-sm')
        .forEach(li => {
          li.classList.toggle('active');
          li.classList.toggle('active-sm');
        });

      $BODY.classList.toggle('nav-md');
      $BODY.classList.toggle('nav-sm');
      sessionStorage.setItem('menu_class', $BODY.className);
      setContentHeight();

      document.querySelectorAll('.dataTable').forEach(tbl => {
        const dt = tbl.DataTable?.(); // nếu DataTables có hỗ trợ khởi tạo
        dt?.draw?.();
      });
    });
  }

    // Xác định menu hiện hành
  $SIDEBAR_MENU.querySelectorAll(`a[href="${CURRENT_URL}"]`).forEach(a => {
    const li = a.parentElement;
    li.classList.add('current-page');
    let parentUl = li.parentElement;
    while (parentUl && parentUl !== $SIDEBAR_MENU) {
      parentUl.style.display = 'block';
      parentUl.parentElement.classList.add('active');
      parentUl = parentUl.parentElement.parentElement;
			slideDown(parentUl);
			setTimeout(setContentHeight, 300);
    }
    setContentHeight();
  });

  // Kéo thả resize
  window.addEventListener('resize', () => {
    clearTimeout(window.smartresizeTimer);
    window.smartresizeTimer = setTimeout(setContentHeight, 200);
  });

  setContentHeight();
  var ulBlock = document.querySelector('.active ul.child_menu');
  if(ulBlock) slideDown(ulBlock);
}
function slideDown(el) {
  el.style.height = el.scrollHeight + "px";
  el.style.transition = "height 0.3s ease";
}
function slideUp(el) {
  el.style.height = "0px";
  el.style.transition = "height 0.3s ease";
}



document.body.addEventListener('click', function (event) {
    startMenuOha();
});